var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFillZeroMoney = function SvgFillZeroMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 195,
    height: 88,
    fill: "none",
    viewBox: "0 0 195 88"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6CA9FF",
    d: "M99.553 15.313v62.832c0 5.014-3.344 9.078-7.47 9.078H7.47C3.344 87.223 0 83.16 0 78.145V15.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A8CFF",
    d: "M99.553 15.313v48.8c0 5.014-3.344 9.078-7.47 9.078L41.626 87.223H7.47C3.344 87.223 0 83.16 0 78.145V15.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D8DD",
    d: "M4.584 15.316h90.569v60.786c0 3.817-3.192 6.922-7.114 6.922H11.697c-3.922 0-7.113-3.105-7.113-6.922z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E6E9",
    d: "M4.584 15.316h90.569v59.056c0 3.817-3.192 6.922-7.114 6.922H11.697c-3.922 0-7.113-3.105-7.113-6.922z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D8DD",
    d: "M4.584 15.316h90.569v56.287c0 3.817-3.192 6.922-7.114 6.922H11.697c-3.922 0-7.113-3.105-7.113-6.922z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EBEE",
    d: "M4.584 15.316h90.569v54.547c0 3.817-3.192 6.922-7.114 6.922H11.697c-3.922 0-7.113-3.105-7.113-6.922z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBC1C7",
    d: "M4.584 15.316h90.569v55.526c0 1.76-1.464 3.184-3.273 3.184H7.856c-1.81 0-3.272-1.424-3.272-3.184z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6CA9FF",
    d: "M7.53 2.52h84.625c4.126 0 7.47 4.064 7.47 9.077v50.947c0 5.014-3.344 9.078-7.47 9.078H7.53c-4.126 0-7.47-4.064-7.47-9.078V11.597c.01-5.013 3.354-9.077 7.47-9.077"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A3C9FF",
    d: "M.071 15.313h99.553V62.63c0 4.015-3.344 7.268-7.47 7.268H7.53c-4.126 0-7.47-3.253-7.47-7.268V15.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6CA9FF",
    d: "M.07 8.046C.07 4.03 3.415.777 7.53.777h84.624c4.126 0 7.47 3.254 7.47 7.269v7.268H.07zM87.185 48.094h-7.47c-1.375 0-2.49 1.084-2.49 2.422v7.269c0 1.338 1.115 2.422 2.49 2.422h7.47c1.375 0 2.49-1.084 2.49-2.422v-7.268c0-1.339-1.115-2.423-2.49-2.423M69.766 48.094h-7.47c-1.374 0-2.49 1.084-2.49 2.422v7.269c0 1.338 1.116 2.422 2.49 2.422h7.47c1.375 0 2.49-1.084 2.49-2.422v-7.268c0-1.339-1.115-2.423-2.49-2.423M52.337 48.094h-7.47c-1.374 0-2.49 1.084-2.49 2.422v7.269c0 1.338 1.116 2.422 2.49 2.422h7.47c1.375 0 2.49-1.084 2.49-2.422v-7.268c0-1.339-1.115-2.423-2.49-2.423M128.943 81.941c-3.557-3.708-5.335-8.939-5.335-15.703v-44.47c0-6.763 1.778-12.004 5.335-15.703C132.5 2.357 137.632.508 144.339.508s11.84 1.849 15.397 5.557 5.335 8.94 5.335 15.704v44.47c0 6.763-1.778 12.004-5.335 15.702-3.557 3.709-8.689 5.558-15.397 5.558q-10.06.002-15.396-5.558m22.48-14.862v-46.16c0-5.558-2.358-8.337-7.084-8.337s-7.073 2.779-7.073 8.336v46.16q0 8.337 7.073 8.337c4.716 0 7.084-2.779 7.084-8.336"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A8CFF",
    d: "M155.366 44s-.864 13.538 9.715 20.213V54.106z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A3C9FF",
    d: "M175.183 63.28c10.944 0 19.817-8.632 19.817-19.282s-8.873-19.283-19.817-19.283-19.817 8.633-19.817 19.283 8.872 19.283 19.817 19.283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6CA9FF",
    d: "m183.719 40.763.63-2.126a.397.397 0 0 0-.386-.504h-2.53a.4.4 0 0 0-.397.306l-2.063 8.683-2.286-8.693a.4.4 0 0 0-.397-.296h-2.245a.41.41 0 0 0-.397.296l-2.297 8.693-2.052-8.683a.4.4 0 0 0-.397-.306h-2.53c-.275 0-.468.257-.386.504l.63 2.126h-2.887a.4.4 0 0 0-.406.396v2.156c0 .217.183.395.406.395h3.75l2.175 7.357a.41.41 0 0 0 .386.287h2.348a.4.4 0 0 0 .386-.287l2.388-7.98 2.389 7.98c.05.168.213.287.386.287h2.358a.39.39 0 0 0 .386-.287l2.154-7.357h3.75a.4.4 0 0 0 .407-.395v-2.156a.4.4 0 0 0-.407-.396h-2.886z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A3C9FF",
    d: "M184.502.5c-1.006 9.216-10.498 10.215-10.498 10.215s9.482.999 10.498 10.215C185.508 11.714 195 10.715 195 10.715S185.518 9.716 184.502.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h195v87H0z"
  })))));
};
export default SvgFillZeroMoney;